//Добавление в корзину
import {BitrixVue} from 'ui.vue3';
import {EventEmitter} from 'main.core.events';
import {Counter} from "../../counter/src/Counter";
import { createPinia, defineStore, mapState, mapActions, setActivePinia } from 'ui.vue3.pinia';
import {store} from "../../store/src/Store";


export class ChangeBasket extends EventEmitter
{
	#store;

	constructor(options = {
		elementId: '',
		priceBlockId:'',
		productId: 0,
		measureRatio:0,
		unit: 'шт',
		type: 'small',
		iconPlus: '',
		iconMinus: '',
		minQuantity: 0,
		maxQuantity: 0,
		mainId: 0,
	})
	{
		super();

		this.setEventNamespace('BX.Asteq.ChangeBasket');

		this.#store = createPinia();

		const context = this;

		const Application = BitrixVue.createApp({
			components:{
				Counter
			},
			beforeCreate() {
				this.$bitrix.Application.set(context);
			},
			data(){
				return {
					quantity: 0,
					measureRatio:1,
					isLoading:false,
					basketItem: null,
					productId: null
				}
			},
			created(){
				this.options = options;
				this.measureRatio = options.measureRatio;
				this.unit = options.unit;
				this.type = options.type;
				this.minQuantity = options.minQuantity;
				this.maxQuantity = options.maxQuantity;
				this.productId = options.productId;
				this.mainId = options.mainId;
			},
			mounted(){
				if(this.basket){
					let item = this.basket?.items?.find(item=>item.productId==options.productId);
					if(item){
						this.basketItem = item;
						this.quantity = item.quantity;
					}
				}
				EventEmitter.subscribe('BX.Asteq.Basket:refresh', () => this.refresh());
			},
			methods: {
				resolveMinQuantity(){
					const raw = this.minQuantity ?? options.minQuantity ?? this.measureRatio ?? 1;
					const qty = Number(raw);
					return qty > 0 ? qty : 1;
				},
				normalizeResponseQuantity(data, fallback){
					if (data != null && data.quantity !== undefined && data.quantity !== null) {
						const qty = Number(data.quantity);
						if (!Number.isNaN(qty) && qty >= 0) {
							return qty;
						}
					}
					const fb = Number(fallback);
					if (!Number.isNaN(fb) && fb >= 0) {
						return fb;
					}
					return 0;
				},
				updateOffer(data){ // /ajax/js_item_detail.php -> window['basketItem-'+(obj.MAIN_ID)]
					if (data.productId != null) {
						this.productId = data.productId;
					}
					if (data.minQuantity != null && data.minQuantity !== '') {
						this.minQuantity = data.minQuantity;
					}
					if (data.maxQuantity != null && data.maxQuantity !== '') {
						this.maxQuantity = data.maxQuantity;
					}
					if (data.measureRatio != null) {
						this.measureRatio = data.measureRatio;
					}
					this.refresh();
				},
				refresh() {
					const root = document.getElementById(options.elementId);
					if (root && root.closest('.select-spare__container')) {
						return;
					}

					if(this.basket){
						let item = this.basket?.items?.find(item=>item.productId==this.productId);
						if(item){
							this.basketItem = item;
							this.quantity = item.quantity;
						} else {
							this.basketItem = null;
							this.quantity = 0;
						}
					} else {
						this.basketItem = null;
						this.quantity = 0;
					}
				},
				request(value){

					this.isLoading = true;
					let requestData = {
						item: this.productId,
						quantity: value,
						custom_add_item: 'Y',
						iblockID: options.iblockID,
					};

					let _this = this;
					return new Promise((resolve, reject) => {
						$.ajax({
							type: "POST",
							url: "/ajax/item.php",
							data: requestData,
							dataType: "json",
							success: function (data) {
								if ('STATUS' in data && data.STATUS !== 'OK') {
									showBasketError(BX.message(data.MESSAGE) + ' <br/>' + data.MESSAGE_EXT);
									reject(data);
								} else {
									if ($("#ajax_basket").length) window.reloadTopBasket("add", $("#ajax_basket"), 200, 5000, "Y");

									if (_this.quantity < value){
										window.addBasketCounter(_this.productId);
									} else if (_this.quantity > value){
										window.delFromBasketCounter(_this.productId);
									}
									_this.quantity = _this.normalizeResponseQuantity(data, value);
									if (_this.quantity <= 0) {
										_this.basketItem = null;
									}
									_this.$Bitrix.Application.get().change();

									resolve(data);
								}
							},
							error: function () {
								reject();
							},
							complete: function () {
								_this.isLoading = false;
							},
						});
					});
				},
				updateBasketPreorders () {
					$.ajax({
						url: "/ajax/getAjaxBasketPreorders.php",
						type: "POST",
						success: function (data) {
							if (data.AMOUNT_TOTAL && document.querySelector('.table-view--basket-preorders._amount-total .table-view--basket-preorders__value')) {
								document.querySelector('.table-view--basket-preorders._amount-total .table-view--basket-preorders__value').innerHTML = data.AMOUNT_TOTAL;
							}

							if (data.PRICE_TOTAL && document.querySelector('.table-view--basket-preorders._price-total .table-view--basket-preorders__value')) {
								document.querySelector('.table-view--basket-preorders._price-total .table-view--basket-preorders__value').innerHTML = data.PRICE_TOTAL;
							}
						},
					});
				},
				getActualBasket (iblockId) {
					var data = { iblockID: iblockId };
					$.ajax({
						type: "GET",
						url: arAsproOptions["SITE_DIR"] + "ajax/actualBasket.php",
						data: data,
						success: function (data) {
							if (!$(".js_ajax").length) $("body").append('<div class="js_ajax"></div>');
							$(".js_ajax").html(data);
						},
					});
				},
				add(){
					const qty = this.resolveMinQuantity();
					let requestData = {
						item: this.productId,
						quantity: qty,
						custom_add_item: 'Y',
						iblockID: options.iblockID,
					};

					this.isLoading = true;

					let _this = this;
					$.ajax({
						type: "POST",
						url: "/ajax/item.php",
						data: requestData,
						dataType: "json",
						success: function (data) {
							if ('STATUS' in data && data.STATUS !== 'OK') {
								showBasketError(BX.message(data.MESSAGE) + ' <br/>' + data.MESSAGE_EXT);
							} else {
								window.addBasketCounter(_this.productId);

								if ($("#ajax_basket").length) window.reloadTopBasket("add", $("#ajax_basket"), 200, 5000, "Y");

								_this.quantity = _this.normalizeResponseQuantity(data, qty);
								_this.$Bitrix.Application.get().change();
							}
						},
						complete: function () {
							_this.isLoading = false;
						},
					});
				}
			},
			computed:{
				basket: () => store().basket,
				showCounter(){
					return Number(this.quantity) > 0;
				},
				prepareTotal(){
					if(this.basketItem){
						return this.basketItem.sum || this.basketItem.totalPriceFormatted;
					}
					return '';
				},
				location: () => window.asteqLocation
			},
			template: `
			<Counter
				:key="productId"
				v-show="showCounter"
				:class="{'counter--active':showCounter, 'basket-btn-loading':isLoading}"
				v-model="quantity" 
				:callback="request" 
				:desc="prepareTotal"
				:ratio="measureRatio"
				:unit="unit"
				:maxQuantity="maxQuantity"
			></Counter>
			<span v-show="!showCounter"
				:disabled="isLoading" 
				@click="add()" 
			 class="" >
			 <span class="counter-block__btn btn" 
				:class="{'basket-btn-loading':isLoading}">В корзину</span>
			 <span class="ripple ripple-animate" style="height: 117.375px; width: 117.375px; animation-duration: 0.6s; animation-timing-function: linear; background: rgb(255, 255, 255); opacity: 0.4; top: -45.4688px; left: 7.9375px;"></span>
			</span>
		`
		});

		window['basketItem'+options.mainId] = Application.mount('#'+options.elementId);
	}

	change(){
		this.emit('change');
	}

	openChangeLocation(){
		this.emit('changeLocation');
	}
}
